/*
 * window.SATSalesRank — the one shared "who's actually selling" signal, used
 * by every spot on the site that picks a handful of products to put in front
 * of a shopper without a merchant having to hand-order them: the home
 * "Featured This Week" six (assets/sat-home-featured-patch.js) and The
 * Southern Air Import's home-page teaser (assets/sat-import-pager-patch.js).
 * Pulled out of sat-home-featured-patch.js (which used to carry its own
 * private copy of this list) so both places rank against the exact same
 * data instead of two lists that can quietly drift apart.
 *
 * RANK is real order-count-and-revenue data pulled from this shop's own
 * analytics (ShopifyQL `FROM sales SHOW gross_sales, net_sales, orders GROUP
 * BY product_title ORDER BY gross_sales DESC`, trailing 365 days, captured
 * 2026-09-10 — supersedes the 2026-09-09 pull the old copy of this list
 * carried). It's a snapshot, not a live query — re-pull and refresh
 * periodically as real sales accumulate, the same tradeoff
 * assets/sat-import-pager-patch.js's own PAGE1_PINNED_HANDLES makes for the
 * Import's page-1 order.
 *
 * bestSellersFirst() sorts a pool by two signals, in order:
 *   1. In stock beats sold out. A title can rank #1 on RANK below and still
 *      have nothing left on the shelf — that's real demonstrated demand, but
 *      it's a bad pick for the site's most visible spotlight if a shopper
 *      can't actually buy it there. Out-of-stock items still show (this is a
 *      ranking signal, not a filter — they sort to the back of their pool,
 *      not out of it), the same tradeoff RANK itself makes for products with
 *      no sales history yet.
 *   2. RANK order among items that tie on stock. A product with no sales
 *      history yet sorts after every product that has one, stable order
 *      among itself.
 */
(function () {
  'use strict';

  var RANK = [
    'German Tricot Long Sleeve Shirt',
    'BRAND NEW Bundeswehr Flecktarn Field Shirt',
    'Issued Greek Lizard Field Pants',
    'Bexar Blood Weapon Lube by Bexar Arms - 2oz',
    'USMC Double Mag Pouch',
    'Czech Wool Socks',
    'GERMAN OD WET WEATHER PONCHO USED',
    'German Flecktarn Wet Weather Suspenders LIKE NEW',
    'Bundeswehr Flecktarn Field Pants Issued',
    'TAZ 83 Alpenflage Field Pants Issued',
    'US Army OCP Trousers(Used)',
    'Czech Bandages',
    'USMC Sustainment Pouches',
    'Bexar Blood Weapon Lube by Bexar Arms- 0.5oz',
    'Flecktarn Winter Field Cap'
  ];

  function rankOf(p) {
    var i = RANK.indexOf(String((p && p.name) || '').trim());
    return i === -1 ? RANK.length : i;
  }

  function bestSellersFirst(pool) {
    return (pool || [])
      .map(function (p, i) { return { p: p, i: i }; })
      .sort(function (a, b) {
        var stockA = (a.p.stock > 0) ? 0 : 1;
        var stockB = (b.p.stock > 0) ? 0 : 1;
        return stockA - stockB || rankOf(a.p) - rankOf(b.p) || a.i - b.i;
      })
      .map(function (x) { return x.p; });
  }

  window.SATSalesRank = { rankOf: rankOf, bestSellersFirst: bestSellersFirst, list: RANK.slice() };
})();
